(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     1.  CONFIGURATION
  ────────────────────────────────────────────────────────── */

  const WFS_CONFIG = {

    /* Product types that trigger the popup */
    triggerProductTypes: [
      'laminate standard plank',
      'laminate herringbone',
      'engineered plank',
      'engineered herringbone',
      'stairs',
      'spc',
      'spc herringbone',
    ],

    /* UNDERLAY PRODUCTS */
    underlayProducts: {
      '10m2':  4191856754785,   // Acousta Gold 3mm  — covers 11 yd² per roll
      '15m2':  4192207011937,   // Superior Silver   — covers 17 yd² per roll
      'vista': 9590438297929,   // Vista 3mm         — covers 17 yd² per roll
      'ufh':   6807334649953,   // Underfloor Heating — covers 17 yd² per roll
    },

    /* ADHESIVE */
    adhesiveProductId: 4193353236577,   // Recoll Adhesive 15 kg — covers 15 yd²

    /* COVERAGE (yd²) — quantity needed = ceil(cartQty / coverage) */
    coverage: {
      underlay10m2:   11,
      underlay15m2:   17,
      underlayVista:  17,
      underlayUfh:    17,
      adhesive:       15,
    },

    /* SPC PROFILES — keyed by title fragments (lower-case) */
    spcProfiles: [
      { match: ['vintage oak spc'],   productId: 8427777392969, label: 'Light Oak Profiles' },
      { match: ['country oak spc'],   productId: 8427790696777, label: 'Farmhouse Oak Profiles' },
      { match: ['atlas oak spc'],     productId: 8537147769161, label: 'Silver Oak Profiles' },
      { match: ['woodland oak spc'],  productId: 8427790696777, label: 'Rustic Oak Profiles' },
      { match: ['royal oak spc'],     productId: 8427782832457, label: 'Oak Robust Fumed Profiles' },
      { match: ['vienna oak spc'],    productId: 8427790696777, label: 'Rustic Oak Profiles' },
      { match: ['bordeaux oak spc'],  productId: 8427773460809, label: 'Glazed Oak Profiles' },
      { match: ['seaside oak spc'],   productId: 8427777392969, label: 'Light Oak Profiles' },
      { match: ['sand oak spc'],      productId: 8427777392969, label: 'Light Oak Profiles' },
      { match: ['harvest oak spc'],   productId: 8427777392969, label: 'Light Oak Profiles' },
    ],

    /* BEST SELLER IDs (for badge) */
    bestSellerIds: [4192207011937, 4191856754785],

    /*
      PRODUCT HANDLES — required for /products/{handle}.json fetching.
      Find each handle in Shopify Admin → Products → the URL slug shown
      in the product page address bar.

      Format:  numericProductId: 'url-handle'
    */
 
     productHandles: {
      4191856754785: 'acousta-gold-3mm-underlay',
      4192207011937: 'superior-gold-3mm-underlay',
      4193353236577: 'ms-adhesive-14kg-drum',
      4193397440609: 'd3-pva-wood-glue-500ml-bottle',
      9590438297929: 'superior-gold-eva-foam-underlay-15sqm',           // ← UPDATE with real Shopify handle
      6807334649953: 'quick-transfer-underlay-15m-sq',  // ← UPDATE with real Shopify handle
      8427777392969: 'light-oak-profiles',
      8427790696777: 'farmhouse-oak-profiles',
      8537147769161: 'silver-oak-8mmprofiles',
      8427782832457: 'oak-robust-fumed-profiles',
      8427773460809: 'glazed-oak-profiles',
    },

    /* STAIRS ADHESIVE — 1 tub always, regardless of quantity */
    stairsAdhesiveId: 4193397440609,
  };

  /* ──────────────────────────────────────────────────────────
     2.  HELPERS
  ────────────────────────────────────────────────────────── */

  async function fetchProductByHandle(handle) {
    try {
      const res = await fetch(`/products/${handle}.json`);
      if (!res.ok) throw new Error(`HTTP ${res.status} for handle "${handle}"`);
      const data = await res.json();
      return data.product || null;
    } catch (e) {
      console.warn('[WFS] fetchProductByHandle error:', handle, e);
      return null;
    }
  }

  async function fetchProducts(ids) {
    const unique = [...new Set(ids.map(Number))];
    const results = await Promise.all(
      unique.map(id => {
        const handle = WFS_CONFIG.productHandles[id];
        if (!handle) {
          console.error(
            `[WFS] No handle registered for product ID ${id}. ` +
            `Add it to WFS_CONFIG.productHandles. ` +
            `Find the handle in Shopify Admin → Products → the URL slug.`
          );
          return Promise.resolve(null);
        }
        console.log(`[WFS] Fetching product ${id} via handle "${handle}"`);
        return fetchProductByHandle(handle);
      })
    );
    const map = {};
    results.forEach((p, i) => { if (p) map[unique[i]] = p; });
    console.log('[WFS] fetchProducts:', Object.keys(map).length, 'of', unique.length, 'loaded');
    return map;
  }

  function calcUnits(qty, threshold) {
    if (!qty || qty < 1) return 1;
    return Math.ceil(qty / threshold);
  }

  function stripHtml(html, max) {
    const d = document.createElement('div');
    d.innerHTML = html;
    const t = (d.textContent || d.innerText || '').trim();
    return t.length > max ? t.slice(0, max).trimEnd() + '…' : t;
  }

  function firstVariantId(product) {
    return product?.variants?.[0]?.id || null;
  }

  function productImage(product) {
    return product?.images?.[0]?.src || '';
  }

  /* ──────────────────────────────────────────────────────────
     3.  CALCULATOR STATE
  ────────────────────────────────────────────────────────── */

  function getCalculatorState() {
    const areaInput = document.getElementById('mp-area-input');
    const qtyInput  = document.getElementById('mp-qty-input');
    const cfg = window.CALCULATOR_CONFIG || {};

    return {
      areaValue:      parseFloat(areaInput?.value || 0),
      qtyValue:       parseInt(qtyInput?.value   || 0, 10),
      packSize:       cfg.packSize       || 0,
      defaultUnit:    cfg.defaultUnit    || 'm',
      currencySymbol: cfg.currencySymbol || '€',
    };
  }

  /* ──────────────────────────────────────────────────────────
     4.  RECOMMENDATION ENGINE
  ────────────────────────────────────────────────────────── */

  function buildRecommendations(floorProduct, calcState) {
    const recs       = [];
    const titleLower = (floorProduct.title || '').toLowerCase();
    const typeLower  = (floorProduct.type  || '').toLowerCase();
    const cartQtyYd2 = calcState.qtyValue || 1;

    console.log('[WFS] buildRecommendations →', {
      title: floorProduct.title,
      type:  floorProduct.type,
      cartQtyYd2,
    });

    /* ── STAIRS ── */
    if (typeLower.includes('stair')) {
      recs.push({
        productId: WFS_CONFIG.stairsAdhesiveId,
        qty:   1,
        badge: 'recommended',
        reason: 'Required for stair installation',
      });
      console.log('[WFS] Stairs → 1 adhesive');
      return recs;
    }

    /* ── SPC (profiles only, no underlay) ── */
    if (typeLower.includes('spc')) {
      const matchedProfile = WFS_CONFIG.spcProfiles.find(p =>
        p.match.some(m => titleLower.includes(m))
      );
      if (matchedProfile) {
        recs.push({
          productId: matchedProfile.productId,
          qty:   1,
          badge: 'recommended',
          reason: `Matching profile for ${matchedProfile.label}`,
        });
        console.log('[WFS] SPC → profile', matchedProfile.productId);
      } else {
        console.warn('[WFS] SPC product found but no profile match for title:', floorProduct.title);
      }
      return recs;
    }

    /* ── LAMINATE / ENGINEERED ── */

    /* ── FIKA: Adhesive + UFH Underlay ── */
    if (titleLower.includes('fika')) {
      const adhesiveQty = calcUnits(cartQtyYd2, WFS_CONFIG.coverage.adhesive);
      recs.push({
        productId: WFS_CONFIG.adhesiveProductId,
        qty:   adhesiveQty,
        badge: 'recommended',
        reason: 'Required for glue-down Fika installation',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['ufh'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayUfh),
        badge: 'recommended',
        reason: 'Compatible with underfloor heating systems',
      });
      console.log('[WFS] Fika → adhesive + UFH underlay');
      return recs;
    }

    /* ── BAUM: Superior Silver + Vista + UFH ── */
    if (titleLower.includes('baum')) {
      recs.push({
        productId: WFS_CONFIG.underlayProducts['10m2'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlay10m2),
        badge: 'bestseller',
        reason: 'Covers 11 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['15m2'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlay15m2),
        badge: 'bestseller',
        reason: 'Covers 17 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['vista'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayVista),
        badge: 'recommended',
        reason: 'Covers 17 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['ufh'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayUfh),
        badge: 'recommended',
        reason: 'Compatible with underfloor heating systems',
      });
      console.log('[WFS] Baum → Acousta Gold + Superior Silver + Vista + UFH');
      return recs;
    }

    /* ── KONIG ESSENCE PRO: Acousta Gold + Superior Silver + Vista + UFH ── */
    /* Must come BEFORE plain 'konig essence' check */
    if (titleLower.includes('konig essence pro')) {
      recs.push({
        productId: WFS_CONFIG.underlayProducts['10m2'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlay10m2),
        badge: 'bestseller',
        reason: 'Covers 11 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['15m2'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlay15m2),
        badge: 'recommended',
        reason: 'Covers 17 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['vista'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayVista),
        badge: 'recommended',
        reason: 'Covers 17 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['ufh'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayUfh),
        badge: 'recommended',
        reason: 'Compatible with underfloor heating systems',
      });
      console.log('[WFS] Konig Essence Pro → Acousta Gold + Superior Silver + Vista + UFH');
      return recs;
    }

    /* ── KONIG PRESTIGE: Acousta Gold + Superior Silver + Vista + UFH ── */
    if (titleLower.includes('konig prestige')) {
      recs.push({
        productId: WFS_CONFIG.underlayProducts['10m2'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlay10m2),
        badge: 'bestseller',
        reason: 'Covers 11 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['15m2'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlay15m2),
        badge: 'recommended',
        reason: 'Covers 17 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['vista'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayVista),
        badge: 'recommended',
        reason: 'Covers 17 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['ufh'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayUfh),
        badge: 'recommended',
        reason: 'Compatible with underfloor heating systems',
      });
      console.log('[WFS] Konig Prestige → Acousta Gold + Superior Silver + Vista + UFH');
      return recs;
    }

    /* ── KONIG ESSENCE: Acousta Gold + Superior Silver + Vista + UFH ── */
    /* Must come AFTER 'konig essence pro' and 'konig prestige' checks */
    if (titleLower.includes('konig essence')) {
      recs.push({
        productId: WFS_CONFIG.underlayProducts['10m2'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlay10m2),
        badge: 'bestseller',
        reason: 'Covers 11 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['15m2'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlay15m2),
        badge: 'recommended',
        reason: 'Covers 17 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['vista'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayVista),
        badge: 'recommended',
        reason: 'Covers 17 yd² per roll',
      });
      recs.push({
        productId: WFS_CONFIG.underlayProducts['ufh'],
        qty:   calcUnits(cartQtyYd2, WFS_CONFIG.coverage.underlayUfh),
        badge: 'recommended',
        reason: 'Compatible with underfloor heating systems',
      });
      console.log('[WFS] Konig Essence → Acousta Gold + Superior Silver + Vista + UFH');
      return recs;
    }

    /* ── DEFAULT: Acousta Gold 10m² only (all other laminate/engineered) ── */
    const defaultId    = WFS_CONFIG.underlayProducts['10m2'];
    const defaultThres = WFS_CONFIG.coverage.underlay10m2;
    const underlayQty  = calcUnits(cartQtyYd2, defaultThres);
    const isBS         = WFS_CONFIG.bestSellerIds.includes(defaultId);

    recs.push({
      productId: defaultId,
      qty:   underlayQty,
      badge: isBS ? 'bestseller' : 'recommended',
      reason: `Covers ${defaultThres} yd² per roll`,
    });
    console.log('[WFS] Default 10m² underlay → qty', underlayQty);

    return recs;
  }

  /* ──────────────────────────────────────────────────────────
     5.  DOM ELEMENTS
  ────────────────────────────────────────────────────────── */

  const overlay     = document.getElementById('wfs-popup-overlay');
  const closeBtn    = document.getElementById('wfs-close-btn');
  const continueBtn = document.getElementById('wfs-continue-btn');
  const productList = document.getElementById('wfs-products-list');

  if (!overlay) {
    console.warn('[WFS] #wfs-popup-overlay not found — is cross-sell-popup.liquid included?');
    return;
  }

  function openPopup() {
    overlay.style.display = '';
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('wfs-open');
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
  }

  function closePopup() {
    overlay.classList.remove('wfs-open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  closeBtn    && closeBtn.addEventListener('click', closePopup);
  continueBtn && continueBtn.addEventListener('click', () => { closePopup(); window.location.href = '/cart'; });
  overlay.addEventListener('click', e => { if (e.target === overlay) closePopup(); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('wfs-open')) closePopup();
  });

  function showLoading() {
    productList.innerHTML = '<div class="wfs-loading-state">Finding the right accessories…</div>';
    openPopup();
  }

  /* ──────────────────────────────────────────────────────────
     6.  RENDER PRODUCT ROWS
  ────────────────────────────────────────────────────────── */

  function renderProducts(recs, productMap, currencySymbol) {
    if (!recs.length) {
      productList.innerHTML = '<div class="wfs-empty">No accessories required for this product.</div>';
      return;
    }

    const rows = recs.map((rec, i) => {
      const product = productMap[rec.productId];
      if (!product) {
        console.warn('[WFS] Product not in map:', rec.productId, '— check product ID is correct and product is active');
        return '';
      }

      const variantId = firstVariantId(product);
      const priceNum  = parseFloat(product.variants?.[0]?.price || '0');
      const subtotal  = (priceNum * rec.qty).toFixed(2);
      const imgSrc    = productImage(product);

      const badgeHtml = rec.badge === 'bestseller'
        ? '<span class="wfs-badge wfs-badge--bestseller">Best Seller</span>'
        : '<span class="wfs-badge wfs-badge--recommended">Recommended</span>';

      const descHtml = product.body_html
        ? `<div class="wfs-product-desc">${stripHtml(product.body_html, 110)}</div>`
        : '';

      return `
        <div class="wfs-product-row"
             data-variant-id="${variantId}"
             data-product-id="${rec.productId}"
             data-unit-price="${priceNum}"
             style="animation-delay:${i * 0.07}s">
          <div class="wfs-product-img-wrap">
            ${imgSrc ? `<img src="${imgSrc}" alt="${product.title}" loading="lazy">` : ''}
          </div>
          <div class="wfs-product-info">
            <div class="wfs-product-badges">${badgeHtml}</div>
            <div class="wfs-product-name">${product.title}</div>
            ${descHtml}
            <div class="wfs-product-subtotal-row">
              <span class="wfs-product-subtotal-label">Subtotal:</span>
              <span class="wfs-product-subtotal-price wfs-subtotal-display">${currencySymbol}${subtotal}</span>
            </div>
            <div class="wfs-product-actions">
              <div class="wfs-qty-stepper">
                <button class="wfs-qty-btn wfs-qty-minus" aria-label="Decrease quantity">−</button>
                <input  class="wfs-qty-input" type="number" value="${rec.qty}" min="1" max="99" aria-label="Quantity">
                <button class="wfs-qty-btn wfs-qty-plus"  aria-label="Increase quantity">+</button>
              </div>
              <button class="wfs-add-btn" data-variant-id="${variantId}" aria-label="Add ${product.title} to cart">
                <span class="wfs-add-btn-text">ADD TO CART</span>
                <span class="wfs-add-btn-spinner"></span>
              </button>
            </div>
          </div>
        </div>`;
    }).join('');

    productList.innerHTML = rows;

    if (!productList.innerHTML.trim()) {
      productList.innerHTML = '<div class="wfs-empty">No accessories found. Please check product IDs in WFS_CONFIG.</div>';
      return;
    }

    /* Attach row interactions */
    productList.querySelectorAll('.wfs-product-row').forEach(row => {
      const qtyInput   = row.querySelector('.wfs-qty-input');
      const minusBtn   = row.querySelector('.wfs-qty-minus');
      const plusBtn    = row.querySelector('.wfs-qty-plus');
      const addBtn     = row.querySelector('.wfs-add-btn');
      const subtotalEl = row.querySelector('.wfs-subtotal-display');
      const unitPrice  = parseFloat(row.dataset.unitPrice);

      function updateSubtotal() {
        subtotalEl.textContent = currencySymbol + (unitPrice * (parseInt(qtyInput.value, 10) || 1)).toFixed(2);
      }

      minusBtn.addEventListener('click', () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
        updateSubtotal();
      });
      plusBtn.addEventListener('click', () => {
        qtyInput.value = Math.min(99, parseInt(qtyInput.value, 10) + 1);
        updateSubtotal();
      });
      qtyInput.addEventListener('change', () => {
        qtyInput.value = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1));
        updateSubtotal();
      });
      addBtn.addEventListener('click', () => {
        addToCartAjax(row.dataset.variantId, parseInt(qtyInput.value, 10) || 1, addBtn);
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     7.  ADD TO CART
  ────────────────────────────────────────────────────────── */

  async function addToCartAjax(variantId, qty, btn) {
    btn.classList.add('wfs-loading');
    btn.disabled = true;

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const sections   = [];
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        cartDrawer.getSectionsToRender().forEach(s => sections.push(s.id));
      }

      const bodyData = { id: variantId, quantity: qty };
      if (sections.length) {
        bodyData.sections      = sections;
        bodyData.sections_url  = window.location.pathname;
      }

      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(bodyData),
      });

      if (!res.ok) throw new Error(`/cart/add.js returned ${res.status}`);

      const response = await res.json();

      btn.classList.remove('wfs-loading');
      btn.classList.add('wfs-added');
      btn.querySelector('.wfs-add-btn-text').textContent = '✓ ADDED';

      if (response.sections && sections.length) updateCartDrawer(response, cartDrawer);
      refreshCartCount();

    } catch (e) {
      console.error('[WFS] addToCartAjax error', e);
      btn.classList.remove('wfs-loading');
      btn.disabled = false;
      btn.querySelector('.wfs-add-btn-text').textContent = 'TRY AGAIN';
      setTimeout(() => { btn.querySelector('.wfs-add-btn-text').textContent = 'ADD TO CART'; }, 2500);
    }
  }

  function updateCartDrawer(response, cartDrawer) {
    if (!cartDrawer || !response.sections) return;
    cartDrawer.getSectionsToRender().forEach(section => {
      const sectionHtml = response.sections[section.id];
      if (!sectionHtml) return;
      const targetEl = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!targetEl) return;
      const parsed     = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const newContent = parsed.querySelector(section.selector || '.shopify-section');
      if (newContent) targetEl.innerHTML = newContent.innerHTML;
    });
    if (typeof cartDrawer.open === 'function') cartDrawer.open();
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const count = cart.item_count;
        [
          '[data-cart-count]',
          '.cart-count',
          '#CartCount',
          '.header__cart-count',
          '[data-cart-bubble]',
          '.cart-link__bubble',
        ].forEach(sel => {
          document.querySelectorAll(sel).forEach(el => {
            el.textContent = count;
            el.setAttribute('data-cart-count', count);
          });
        });
      })
      .catch(() => {});
  }

  /* ──────────────────────────────────────────────────────────
     8.  MAIN HANDLER
  ────────────────────────────────────────────────────────── */

  async function showCrossSellPopup(floorProduct, options = {}) {
    const calcState  = getCalculatorState();
    const typeLower  = (floorProduct.type || '').toLowerCase();
    const isStairs   = typeLower.includes('stair');
    const shouldTrigger = WFS_CONFIG.triggerProductTypes.some(t => typeLower.includes(t));

    console.log('[WFS] showCrossSellPopup:', {
      title: floorProduct.title,
      type:  floorProduct.type,
      shouldTrigger,
      isStairs,
      cartQty: calcState.qtyValue,
    });

    if (!shouldTrigger) {
      console.log('[WFS] Product type not in trigger list — skipping popup');
      return;
    }

    /* Stairs have no calculator — skip qty validation */
    if (!isStairs && (!calcState.qtyValue || calcState.qtyValue < 1)) {
      console.log('[WFS] No valid quantity — skipping popup');
      return;
    }

    showLoading();

    let recs = buildRecommendations(floorProduct, calcState);
    console.log('[WFS] Recommendations:', recs);

    /* Skip accessories already in the cart (e.g. underlay added via calculator) */
    try {
      const cartRes  = await fetch('/cart.js');
      const cartData = await cartRes.json();
      const cartProductIds = (cartData.items || []).map(i => Number(i.product_id));
      const before = recs.length;
      recs = recs.filter(r => !cartProductIds.includes(Number(r.productId)));
      if (recs.length < before) {
        console.log('[WFS] Filtered accessories already in cart:', before - recs.length);
      }
      if (!recs.length) {
        console.log('[WFS] All recommended accessories already in cart - skipping popup');
        closePopup();
        return;
      }
    } catch (e) {
      console.warn('[WFS] Could not check cart contents:', e);
    }

    if (!recs.length) {
      productList.innerHTML = '<div class="wfs-empty">No accessories required for this product.</div>';
      return;
    }

    const productMap = await fetchProducts(recs.map(r => r.productId));
    console.log('[WFS] Product map:', productMap);

    if (!Object.keys(productMap).length) {
      productList.innerHTML = `
        <div class="wfs-empty">
          Could not load accessory details. Please check the browser console for
          product fetch errors and verify product IDs in WFS_CONFIG are correct
          and the products are active/published.
        </div>`;
      return;
    }

    renderProducts(recs, productMap, calcState.currencySymbol);
  }

  /* ──────────────────────────────────────────────────────────
     9.  HOOK INTO CALCULATOR
  ────────────────────────────────────────────────────────── */

  function attachCalculatorListener() {
    const atcBtn   = document.getElementById('mp-atc-btn');
    const qtyInput = document.getElementById('mp-qty-input');

    if (!atcBtn) {
      console.log('[WFS] #mp-atc-btn not found — popup will not trigger');
      return false;
    }

    atcBtn.addEventListener('click', function () {
      const qty = parseInt(qtyInput?.value || 0, 10);
      if (!qty || qty < 1) {
        console.log('[WFS] ATC clicked but qty is invalid:', qty);
        return;
      }

      const product = window.__wfs_product;
      if (!product || !product.title || !product.type) {
        console.warn('[WFS] window.__wfs_product missing or incomplete:', product);
        return;
      }

      console.log('[WFS] ATC clicked →', { title: product.title, type: product.type, qty });

      /* Small delay so the floor product add-to-cart completes first */
      setTimeout(() => {
        showCrossSellPopup({
          title: product.title,
          type:  product.type,
          id:    product.id,
        });
      }, 600);
    });

    console.log('[WFS] Calculator listener attached to #mp-atc-btn');
    return true;
  }

  /**
   * Stairs products have no calculator — they use the standard Shopify
   * product form. We intercept the native form submit instead.
   */
  function attachStairsListener() {
    const product = window.__wfs_product;
    if (!product) return;

    const typeLower = (product.type || '').toLowerCase();
    if (!typeLower.includes('stair')) return;

    /* Find the Shopify product form on this page */
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) {
      console.log('[WFS] Stairs: no product form found');
      return;
    }

    productForm.addEventListener('submit', function () {
      /* Delay so Shopify processes the add first, then show popup */
      setTimeout(() => {
        showCrossSellPopup({
          title: product.title,
          type:  product.type,
          id:    product.id,
        });
      }, 800);
    });

    console.log('[WFS] Stairs listener attached to product form');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      attachCalculatorListener();
      attachStairsListener();
    });
  } else {
    attachCalculatorListener();
    attachStairsListener();
  }

  console.log('[WFS] Cross-sell popup v6 initialised');

})();
